import React from 'react'
import User from 'EurestoClass/User'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import Grid from '@material-ui/core/Grid/Grid'
import Button from '@material-ui/core/Button/Button'
import Tabs from '@material-ui/core/Tabs/Tabs'
import Tab from '@material-ui/core/Tab/Tab'


import Modal from './Modal'
import AppBar from '@material-ui/core/AppBar/AppBar'

import Utils from 'EurestoFonction/Utils'
import { Fab } from '@material-ui/core'

export default class extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      action: props.action === 'add' && props.isAllow && (props.isAllow.add && props.action || ' ') || props.action,
      key: Utils.getRandomNumber(),
      undefinedRequired: {}
    }
  }

  labelTab = _ => this.state.action === 'view' &&
    (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'} alignItems={'center'}
        alignContent={'center'}>
        <i className={'ei-commun_visualiser'} style={{ fontSize: 18 }} />&nbsp;{this.props.libelle}
      </Grid>
    )
    || this.state.action === 'update' &&
    (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'} alignItems={'center'}
        alignContent={'center'}>
        <i className={'ei-commun_modifier'} style={{ fontSize: 18 }} />&nbsp;{this.props.libelle}
      </Grid>
    )
    || this.state.action === 'add' &&
    (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'} alignItems={'center'}
        alignContent={'center'}>
        <i className={'ei-commun_ajouter'}
          style={{ fontSize: 18 }} />&nbsp;{this.props.libelleAdd || EurestoI18n.t('commun:Nouveau')}
      </Grid>
    )
    || 'Saisie valeur bloquée'

  onUpdate = (e) => {
    this.setState({
      action: 'update'
    }, () => this.props.onUpdate && this.props.onUpdate())
  }

  onDuplicate = (e) => {
    this.setState({
      action: 'add'
    }, () => this.props.onUpdate && this.props.onUpdate())
  }

  onUnarchive = () => {
    this.props.onUnarchive && this.props.onUnarchive()
  }

  onArchive = () => {
    this.setState({
      action: 'archive'
    }, () => this.props.onArchive && this.props.onArchive())
  }

  onCloseDeleteModal = (view) => _ => {
    this.setState({
      showDeleteModal: view
    })
  }

  onSave = () => {
    console.log(this.props.required, this.props.object)
    if (this.props.required && Object.keys(this.props.required).length > 0 && this.props.object === undefined) {
      alert('Vous devez faire passer l\'objet du formulaire pour détecter les champs non renseignés')
      return;
    } else if (this.props.required && Object.keys(this.props.required).length > 0) {
      const requiredNotDefined = Object.keys(this.props.required).filter(required => this.props.object[required] === undefined)
      if (requiredNotDefined && requiredNotDefined.length > 0) {
        this.setState({
          undefinedRequired: requiredNotDefined.map(not => this.props.required[not])
        })
        return
      }
    }
    this.props.onSave(this.state.action)
  }

  onAdd = () => {
    this.props.onCancel()
  }

  onCancel = () => {
    this.props.onView(this.state.action)
  }

  render() {
    let buttons = []
    if (this.state.action === 'view') {
      User.isAddUpdateDeleteAvaibleForMe() && this.props.isAllow && this.props.isAllow.add && buttons.push({
        title: 'Ajouter',
        className: 'EurestoSecondary--text',
        icon: 'ei-commun_ajouter',
        cb: this.onAdd
      })
      User.isAddUpdateDeleteAvaibleForMe() && this.props.isAllow && this.props.isAllow.update && buttons.push({
        title: 'Modifier',
        className: 'EurestoSecondary--text',
        icon: 'ei-commun_modifier',
        cb: this.onUpdate
      })
      User.isAddUpdateDeleteAvaibleForMe() && this.props.isAllow && this.props.isAllow.duplicate && buttons.push({
        title: 'Dupliquer',
        className: 'EurestoSecondary--text',
        icon: 'ei-commun_dupliquer',
        cb: this.onDuplicate
      })
      User.isAddUpdateDeleteAvaibleForMe() && this.props.isAllow && this.props.isAllow.archive && buttons.push({
        title: 'Archiver',
        className: 'EurestoError--text',
        icon: 'ei-commun_archiver',
        cb: this.onArchive
      })
      User.isAddUpdateDeleteAvaibleForMe() && this.props.isAllow && this.props.isAllow.delete && buttons.push({
        title: 'Supprimer',
        className: 'EurestoError--text',
        icon: 'ei-commun_supprimer',
        cb: this.onCloseDeleteModal(true)
      })
      User.isAddUpdateDeleteAvaibleForMe() && this.props.isAllow && this.props.isAllow.unarchive && buttons.push({
        title: 'Désarchiver',
        className: 'EurestoSecondary--text',
        icon: 'ei-commun_reouvrir',
        cb: this.onUnarchive
      })
    } else if (this.state.action === 'update' || this.state.action === 'add' || this.state.action === 'archive' && User.isAddUpdateDeleteAvaibleForMe()) {
      !this.props.isAllow || this.props.isAllow.cancel !== false && buttons.push({
        title: 'Annuler',
        className: 'EurestoError--text',
        icon: 'ei-commun_fermer',
        cb: this.onCancel
      })
      buttons.push({
        title: 'Enregistrer',
        className: 'EurestoSecondary--text',
        icon: 'ei-commun_valider',
        cb: this.onSave
      })
    }
    if (this.props.buttons) {
      buttons = buttons.concat(this.props.buttons.filter(button => button.isAllow))
    }
    const form = (
      <div key={this.state.key} style={{ height: '100%', borderLeft: this.props.borderLeft && '1px solid lightgray', width: '100%' }}>
        {this.props.showTab !== false &&
          <AppBar position="static" color="default"><Tabs
            value={0}
            variant={'fullWidth'}
            centered>
            <Tab label={this.labelTab() || ''} />
          </Tabs></AppBar>}
        <div style={{ position: 'relative', height: '100%' }}>
          <Grid container style={{
            margin: 0,
            padding: 0,
            position: this.props.borderLeft && 'absolute',
            right: this.props.borderLeft && 0,
            top: this.props.borderLeft && -27,
            width: this.props.borderLeft && '100vh' || '100%'
          }} spacing={0}
            justify={this.props.borderLeft && 'flex-end' || 'flex-start'}
            alignItems={'center'}>{
              buttons.map((b, i) => {
                return b.title &&
                  <Button key={i}
                    size={'small'}
                    variant={'contained'}
                    style={{
                      ...(i > 0 && { marginLeft: 5 } || {}),
                      border: '1px solid ' + EurestoColor('EurestoPrimary'),
                      ...(b.style || {}),
                    }}
                    onClick={(e) => {
                      e.stopPropagation()
                      b.cb()
                    }}
                    disabled={b.disabled || false}
                    className={(b.disabled ? 'EurestoDisabled' : 'EurestoText--text ' + (b.className && b.className.replace('--text', '') || 'EurestoPrimary'))}>
                    <Grid container justify={'center'} alignContent={'center'} alignItems={'center'}>&nbsp;<i
                      className={b.icon + ' ' + (b.disabled ? '' : 'EurestoText--text')} />&nbsp;{b.title}&nbsp;
                  </Grid></Button>
                  ||
                  <Fab key={i} style={Object.assign(i > 0 && {
                    marginLeft: 5,
                    //fontSize: 15
                  } || {}, b.style || {})} size="small" onClick={(e) => {
                    e.stopPropagation()
                    b.cb()
                  }}
                    disabled={b.disabled || false}
                    className={(b.disabled ? 'EurestoDisabled' : ('EurestoPrimary ' + b.className))}>
                    <i
                      className={'fa fa-' + b.icon + ' ' + (b.disabled ? '' : 'EurestoText--text')} />
                  </Fab>
              })}</Grid>
          <Grid key={this.state.key + '_update_add_relations'} container
            style={{ position: 'relative', margin: 0, padding: 0, ...(this.props.style || {}) }} spacing={0}
            justify={'flex-start'}
            alignItems={'flex-start'} alignContent={'flex-start'} direction={'column'}>
            {
              Object.keys(this.state.undefinedRequired).map((required, index) => (
                <span key={this.state.undefinedRequired[required] + '-' + index} className={'EurestoError--text'}
                  style={{ textAlign: 'left', fontSize: 11, color: 'tomato' }}>
                  {typeof this.state.undefinedRequired[required] === 'string' && `*** Vous devez renseigner le champ ${this.state.undefinedRequired[required]}`
                    || this.state.undefinedRequired[required].message}
                </span>
              ))
            }
          </Grid>
          <Grid container style={{
            padding: 5, margin: 0, ...(!this.props.borderLeft && {
              backgroundColor: 'white',
              borderRadius: 5,
              border: '1px solid ' + EurestoColor('EurestoPrimary')
            } || {}),
            height: '100%', width: '100%'
          }} spacing={0} onMouseDown={(e) => {
            if (e.shiftKey && this.state.action === 'view' && this.props.onClickUpdate !== false) {
              this.onUpdate(e)
              $(e.target).focus()
            }
          }}>
            {this.props.children(this.state.action === 'view', this.state.action !== 'view')}
          </Grid>
        </div>
        <Modal key={this.state.showDeleteModal} open={this.state.showDeleteModal}
          onClose={this.onCloseDeleteModal(false)}
          grid={{ xs: 5 }}>
          <EurestoDiv
            paddingTopBody={0}
            fromModal={true} style={{
              margin: 0,
              padding: 0,
              overflowY: 'auto'
            }} title={EurestoI18n.t('commun:Confirmation de suppression ')}
            buttonsLeft={[{
              icon: ' ei-commun_fermer',
              className: 'EurestoError--text EurestoText',
              cb: this.onCloseDeleteModal(false)
            }]}
            buttonsRight={[{
              icon: ' ei-commun_valider',
              className: 'text-success',
              cb: () => {
                this.onCloseDeleteModal(false)
                this.props.onDelete && this.props.onDelete()
              }
            }]}>
            <Grid container style={{ margin: 0, padding: 10 }} spacing={0} justify={'flex-start'} alignItems={'center'}>
              <Grid item style={{ margin: 0, padding: 0 }}>
                <span style={{
                  wordWrap: 'break-word',
                  width: '100%',
                  whiteSpace: 'initial',
                }}>{EurestoI18n.t('commun:Êtes-vous sur de vouloir supprimer cet élément ? ') + `(${this.props.libelle})`}</span>
              </Grid>
            </Grid>
          </EurestoDiv>
        </Modal>
      </div>)

    if (this.props.parentComponent) {
      return this.props.parentComponent({
        children: form,
        libelle: this.labelTab() || ''
      })
    }

    return form
  }
}



// WEBPACK FOOTER //
// ./app/Components/Form.js